import { QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { MainRoutes } from './core/router/index'; // Your routes
import DevelopmentUtils from './shared/components/common/development-utils';
import { NewVersionBanner } from './shared/components/common/development-utils/new-version-banner';

import { queryClient } from './core/api/query-client';
import { PostHog } from './shared/components/common/post-hog';
import { setupGlobalErrorHandlers } from './core/api/capture-runtime-error-in-posthog';

import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';

import './style.css';

setupGlobalErrorHandlers();

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <PostHog>
      <BrowserRouter>
        <NewVersionBanner />
        <Toaster />
        <MainRoutes />
        <DevelopmentUtils />
      </BrowserRouter>
    </PostHog>
  </QueryClientProvider>
);
